export const ConfirmationViewTestIds = {
  PROCEED_BUTTON: 'loan-action-confirmation.proceed-button',
  CANCEL_BUTTON: 'loan-action-confirmation.cancel-button',
};
